import { useAppSelector } from "../store/index.ts";
import useDecimalValue from "./useDecimalValue.js";

export default function useBalance() {
  const getRoundedValue = useDecimalValue();
  const balance = useAppSelector((state) => state.user.balance);
  const currency = useAppSelector((state) => state.user.currency);

  const getMainBalance = (currency) => {
    const mainBalance = balance[currency]?.balances?.main;
    return getRoundedValue(mainBalance, currency);
  };

  const getBonusBalance = (currency) => {
    const bonusBalance = balance[currency]?.balances?.bonus;
    return getRoundedValue(bonusBalance, currency);
  };

  const mainBalance = getMainBalance(currency);
  const bonusBalance = getBonusBalance(currency);

  return {
    mainBalance,
    bonusBalance,
    getMainBalance,
    getBonusBalance
  };
}
